import { language } from '@tencent/ppd-base-libs';
import { getMapLang } from '@/utils';
/** 格式化地区名字 */
export function formatAreaName(data) {
  return data && data[getMapLang()];
}
/** 格式化头图 */
export function formatHeaderLogo(data) {
  if (language.isEn() && data?.headerLogoEn) {
    return data.headerLogoEn;
  }
  if (language.getLanguage() === 'zh-cn' && data?.headerLogoCn) {
    return data.headerLogoCn;
  }
  return data?.headerLogo;
}
